export function getCmsBaseUri() {
    const headElm = getHeadElm();
    return decodeURIComponent(headElm?.dataset.cmsbaseurl || '/');
}

export function getGtmServerSideId() {
    const headElm = getHeadElm();
    return headElm?.dataset.gtmssid;
}

export function getGtmServerSideUrl() {
    const headElm = getHeadElm();
    return decodeURIComponent(headElm?.dataset.gtmssurl || '/');
}

export function getLoadGtmWithoutCookieCheck() {
    const headElm = getHeadElm();
    return headElm?.dataset.loadgtmwithoutcookiecheck?.toLowerCase() === 'true';
}

export function getCountryApp(): string | undefined {
    const headElm = getHeadElm();
    return headElm?.dataset.gtmcountryapp?.toUpperCase();
}

export function getNonceId() {
    const headElm = getHeadElm();
    return headElm?.dataset.nonceid;
}

function getHeadElm() {
    return document.getElementById('head');
}

export function getChannel() {
    const headElm = getHeadElm();
    return headElm?.dataset.channel;
}
